import { Controller } from '@hotwired/stimulus'

// Inline preview for a single image file field (shop logo, cover photo, etc.).
export default class extends Controller {
  static targets = ['input', 'image', 'fallback']

  connect () {
    this.previewUrl = null
  }

  disconnect () {
    this.revokePreviewUrl()
  }

  change () {
    const file = this.inputTarget.files?.[0]
    this.revokePreviewUrl()

    if (!file || !this.isImage(file)) return

    this.previewUrl = URL.createObjectURL(file)
    if (this.hasImageTarget) {
      this.imageTarget.src = this.previewUrl
      this.imageTarget.classList.remove('hidden')
    }
    if (this.hasFallbackTarget) this.fallbackTarget.classList.add('hidden')
  }

  isImage (file) {
    if (file.type?.startsWith('image/')) return true
    const ext = (file.name || '').split('.').pop()?.toLowerCase()
    return ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'heic', 'heif', 'avif'].includes(ext)
  }

  revokePreviewUrl () {
    if (!this.previewUrl) return
    URL.revokeObjectURL(this.previewUrl)
    this.previewUrl = null
  }
}
